var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "RouterLink",
    {
      staticClass: "dropdown__item",
      class: { "has-separator": _vm.item.separator },
      style: _vm.item.cssStyle,
      attrs: { tag: _vm.tag, to: _vm.item.route ? _vm.item.route : {} },
      nativeOn: {
        click: function($event) {
          return _vm.onClick($event)
        }
      }
    },
    [
      _vm.item.icon ? _c("i", { class: _vm.item.icon }) : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.L(_vm.item.text)) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }